import { useEditorContext } from "../EditorContext";
import {
  getBorderStyleObj,
} from "../FormText/FormBaseStyle";
import FormLabel from "./FormLabel";

export default ({ data }) => {
  const {
    placeholder,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  const { state } = useEditorContext();

  const borderStyleObj = getBorderStyleObj(state.root.data);

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
      }}
    >
      <FormLabel data={data} />
      <div
        style={{
          height: 38,
          display: "flex",
          alignItems: "center",
          ...borderStyleObj,
        }}
      >
        {placeholder && (
          <div
            style={{
              padding: "0 8px",
              color: "#707070",
            }}
          >
            {placeholder}
          </div>
        )}
      </div>
    </div>
  );
};
